import { HStack } from '@chakra-ui/react';
import * as React from 'react';

import {
  AttachmentButton,
  AttachmentPreview,
  Body,
  Container,
  ImageButton,
  ImagePreview,
  Title,
} from '@/components/post-form';

import { PostSettings } from '../PostSettings';

export const QuestionForm: React.FC<{
  organizationId?: string;
  initialGroupId?: string;
  originalImages?: { imageId: string; imageProxy: string }[];
  isEditing?: boolean;
  isPublished?: boolean;
}> = ({
  organizationId,
  initialGroupId,
  originalImages,
  isEditing,
  isPublished,
}) => {
  const validationMessage = 'A question requires a title or body.';

  return (
    <Container>
      <Title
        formLabel="Question Title"
        placeholder="What is your question?"
        validationMessage={validationMessage}
      />
      <Body
        formLabel="Description"
        placeholder="Write a description for your question"
        validationMessage={validationMessage}
      />
      <HStack>
        <ImageButton imageLimit={20} />
        <AttachmentButton attachmentLimit={10} />
      </HStack>
      <ImagePreview originalImages={originalImages} />
      <AttachmentPreview />

      <PostSettings
        isEditing={!!isEditing}
        isPublished={!!isPublished}
        initialGroupId={initialGroupId}
        organizationId={organizationId}
      />
    </Container>
  );
};
